'use client'

import React from 'react';
import Section from "@/components/partials/section";
import Card from "@/components/partials/card";

type ContentItem = {
    imageSrc: string;
    title: string;
    subTitle: string;
    description: string;
};

type ClientsBlockProps = {
    data: {
        alignment: string,
        leading: string;
        title: string;
        description: string;
        content: ContentItem[];
    };
};

const ClientsBlock = ({ data }: ClientsBlockProps) => {
    const { leading, alignment, title, description, content } = data;

    return (
        <Section
            id={ClientsBlock.name}
            header={{
                classGroup: {
                    h1: "text-3xl sm:text-6xl",
                },
                leading,
                alignment: alignment,
                title,
                description
            }}
        >
            <Card
                id={ClientsBlock.name + `-cards`}
                cardClassName="flex-col px-1 rounded-lg"
                ariaLabel={title}
                cardGrid={3}
                content={content}
            />
        </Section>
    );
};

export default ClientsBlock;
